import { ChatPageContextData, ChatDetailsResponse } from '@choco-admin/types';
import React, { createContext, useContext, useState, ReactNode } from 'react';

interface ExtendedChatPageContextData extends ChatPageContextData {
  chatData: ChatDetailsResponse | null;
  setChatData: (data: ChatDetailsResponse | null) => void;
  updateChatData: (
    updater: (prev: ChatDetailsResponse | null) => ChatDetailsResponse | null
  ) => void;
}

const ChatPageContext = createContext<ExtendedChatPageContextData | undefined>(
  undefined
);

export const useChatPageContext = (): ExtendedChatPageContextData => {
  const context = useContext(ChatPageContext);
  if (!context) {
    throw new Error(
      'useChatPageContext must be used within a ChatPageContextProvider'
    );
  }
  return context;
};

interface ChatPageContextProviderProps {
  children: ReactNode;
  initialChatData?: ChatDetailsResponse | null;
}

export const ChatPageContextProvider: React.FC<
  ChatPageContextProviderProps
> = ({ children, initialChatData = null }) => {
  const [pageErrorFields, setPageErrorFields] = useState<string[]>([]);
  const [chatData, setChatData] = useState<ChatDetailsResponse | null>(
    initialChatData
  );

  const updateChatData = (
    updater: (prev: ChatDetailsResponse | null) => ChatDetailsResponse | null
  ) => {
    setChatData(updater);
  };

  const contextValue: ExtendedChatPageContextData = {
    pageErrorFields,
    setPageErrorFields,
    chatData,
    setChatData,
    updateChatData,
  };

  return (
    <ChatPageContext.Provider value={contextValue}>
      {children}
    </ChatPageContext.Provider>
  );
};
